export enum UserNoticeSectionType {
    Open = 0,
    Closed,
    DeadDeals,
    Repaid,
    Missing,
    All,
}
